import React from 'react';
import FeatherIcon from 'feather-icons-react';
import { MenuGroupProps } from '../__base';
import { GlobalUrl } from '@/routers/globalRouters';
import { CompanyIcon, HomeIcon } from '@/assets/icons/entities/_';

export const MonitoringMenu: MenuGroupProps[] = [
  {
    groupName: 'menu.MainMenu',
    items: [
      {
        icon: <HomeIcon />,
        title: 'menu.Dashboard',
        key: 'dashboard',
        to: '/cms/dashboard',
        permissions: '*',
      },
    ],
  },
  {
    groupName: 'menu.SystemSettings',
    items: [
      // {
      //   icon: <CompanyIcon />,
      //   title: 'menu.Companies',
      //   key: 'companies',
      //   to: GlobalUrl.Monitoring.Companies,
      //   roles: '*',
      // },
    ],
  },
];
